import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup,FormControl , Validators, MinLengthValidator} from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  templateUrl : './educationalformsemgpa.component.html',
   providers: [ ConfirmationService]
})
export class addEducationalDetailsSemesterGPA implements OnInit {
  FeedbackForm : FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  @Input() showSpecialization: string;
  @Input() course_name_auto : string;
  @Input() college_year_auto : string;
  @Input() enrollment_year_auto: number;
  @Input() specialisationlevel_auto: number;
  @Input() leaving_year_auto: number;
  @Input() start_year: any;
  @Input() seat_number: any;
  @Input() mu_seat_number: any;
  @Input() sgpi_gpa : any;

  validations_flag = false;
  feedback_message ;
  showExperience = false;
 

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation  = true;
  monthValidation  = true;
  yearValidation = true;
  attemptValidation  = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  totalValue: number;
  totalValue2: number;
  totalValue3: number;
  totalValue4: number;
  totalValue5: number;
  totalValue6: number;
  totalValue7: number;
  totalValue8: number;
  totalValue9: number;
  totalValue10: number;

  total_value1: number;
  total_value2: number;
  total_value3: number;
  total_value4: number;
  total_value5: number;
  total_value6: number;
  total_value7: number;
  total_value8: number;
  total_value9: number;
  total_value10: number;
  over_All_Total: number;

  C_into_G: number;
  C_into_G2: number;
  C_into_G3: number;
  C_into_G4: number;
  C_into_G5: number;
  C_into_G6: number;
  C_into_G7: number;
  C_into_G8: number;
  C_into_G9: number;
  C_into_G10: number;

  totalMarks: number;
  totalMarksOut: number;
  creditTotal: number;
  totalCnG : number;
  totalcgpa: number;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  monthTaken2: any;
  monthTaken1: any;
  monthTaken3: any;
  monthTaken8: any;
  monthTaken7: any;
  monthTaken6: any;
  monthTaken5: any;
  monthTaken4: any;
  hourValue9: any;
  hourValue10: any;
  lecVal9: any;
  lecVal10: any;
  monthTaken9: any;
  monthTaken10: any;

  endmonthValidation = true;
  endYearValidation = true;
  enrollYear = [];
  enrollment_year:any;
 
  predictive_data;
  specialisation_data;
  specialisation_name: any;
  show_predictive: boolean =false;

  hourPreValue : any;
  hourPreValue2 : any;
  hourPreValue3 : any;
  hourPreValue4 : any;
  hourPreValue5 : any;
  hourPreValue6 : any;
  hourPreValue7 : any;
  hourPreValue8 : any;
  hourPreValue9 : any;
  hourPreValue10 : any;
 
  lecPreValue: any;
  lecPreValue2 : any;
  lecPreValue3 : any;
  lecPreValue4 : any;
  lecPreValue5 : any;
  lecPreValue6 : any;
  lecPreValue7 : any;
  lecPreValue8 : any;
  lecPreValue9 : any;
  lecPreValue10 : any;

  monthsPreTaken:any
  monthsPreTaken2:any
  monthsPreTaken3:any
  monthsPreTaken4:any
  monthsPreTaken5:any
  monthsPreTaken6:any
  monthsPreTaken7:any
  monthsPreTaken8:any
  monthsPreTaken9:any
  monthsPreTaken10:any

  subjectPreName : any;
  subjectPreName2 : any;
  subjectPreName3 : any;
  subjectPreName4 : any;
  subjectPreName5 : any;
  subjectPreName6 : any;
  subjectPreName7 : any;
  subjectPreName8 : any;
  subjectPreName9 : any;
  subjectPreName10 : any;

  crerditsPre1 : any
  crerditsPre2 : any
  crerditsPre3 : any
  crerditsPre4 : any
  crerditsPre5 : any
  crerditsPre6 : any
  crerditsPre7 : any
  crerditsPre8 : any
  crerditsPre9 : any
  crerditsPre10 : any
   
  
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7= new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2:  any;
  course_code3: any;
  course_code4:  any;
  course_code5: any;
  course_code6:  any;
  course_code7: any;
  course_code9:  any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3 : any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  specialInstructionArray = ['@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A',
                              '& Scaled Down, Cir. No. UG/61 of 2013-2014',
                            '+ Carried Forward Marks as per Ordinance of University of Mumbai',
                            '* As per University of Mumbai Ordinance 0.5045a',
                            '$ - Carried forward grade as per ordinance of the University of Mumbai',
                            '# As per University of Mumbai, Ordinance 0.229'
                            ]
  specialInstruction: any;
  specI: any;
  remarks : any;
  GradespecialInstruction: any;
  DradespecI: any;
  newcourse_code = [];
  course_name: any;
  edu_level: any;
  college_year: any;
  semester_auto: any;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;

 
  preEditFirst: boolean = false;
  preEditSecond: boolean = false;
  preEditThird: boolean = false;
  preEditFourth: boolean = false;
  preEditFifth: boolean = false;
  preEditSixth: boolean = false;
  preEditSeventh: boolean = false;
  preEditEight: boolean = false;
  preEditNinth: boolean = false;
  preEditTenth: boolean = false;

  editShow1 : boolean = false;
  editShow2 : boolean = false;
  editShow3 : boolean = false;
  editShow4 : boolean = false;
  editShow5 : boolean = false;
  editShow6 : boolean = false;
  editShow7 : boolean = false
  editShow8 : boolean = false;
  editShow9 : boolean = false;
  editShow10 : boolean = false;

  instruction1: boolean =false;                          
  instruction2: boolean =false;                          
  instruction3: boolean =false;                          
  instruction4: boolean =false;                          
  instruction5: boolean =false;                          
  instruction6: boolean =false;
  instruction7: boolean =false;    

  special_instruction1: any = null;                          
  special_instruction2: any = null;                          
  special_instruction3: any = null;                          
  special_instruction4: any = null;                          
  special_instruction5: any = null;                          
  special_instruction6: any = null; 
  special_instruction7: any = null; 
  
  subjectArray = [];
  subjectArray2 = [];
  subjectArray3 = [];
  subjectArray4 = [];
  subjectArray5 = [];
  subjectArray6 = [];
  subjectArray7 = [];
  subjectArray8 = [];
  subjectArray9 = [];
  subjectArray10 = [];

  isDisabled = false;
  startmonth ;
  startYear;
  startyear: any;
  yearStart;
  start__year: any;
  courseCodePreName: any;
  courseCodePreName2: any;
  courseCodePreName3: any;
  courseCodePreName4: any;
  courseCodePreName5: any;
  courseCodePreName6: any;
  courseCodePreName7: any;
  courseCodePreName8: any;
  courseCodePreName9: any;
  courseCodePreName10: any;
  still_studying: any;
  stillStudy: any;
  applicant_specialisation;
  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    public toasterService: NbToastrService,
     private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<addEducationalDetailsSemesterGPA>) { }

  async ngOnInit() {
    
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }
    this.yearStart = this.start_year;

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: [ '' ,  Validators.required],
      collegeYearCtrl : [ '' ,  Validators.required],
      semesterCtrl : [ '' ,  Validators.required],
      monthCtrl : [ '' ,  Validators.required],
      yearCtrl : [ '' ,  Validators.required],
      endyearCtrl: [ '' ],
      endmonthCtrl : [ '' ],
      stlStdmonthCtrl :  [''],
      overAllGradeCtrl : [ '' ,],
      overAllgpasgpiCtrl : [ ' ',Validators.required,],
      subjectFirstCtrl : [ '' ],
      // subjectPreFirstCtrl : [''],
      markFirstCtrl : [ '' ,  Validators.required],
      markFirstOutCtrl : [ '' ,  Validators.required],
      gradeFirstCtrl : [ '' ,  Validators.required],
      subjectSecondCtrl : [ '' ],
      markSecondCtrl : [ '' ],
      markSecondOutCtrl : [ '' ],
      gradeSecondCtrl : [ '' ],
      subjectThirdCtrl : [ '' ],
      markThirdCtrl : [ ''],
      markThirdOutCtrl : [ ''],
      gradeThirdCtrl : [ ''],
      subjectFourthCtrl : [ '' ],
      markFourthCtrl : [ '' ],
      markFourthOutCtrl : [ '' ],
      gradeFourthCtrl : [ '' ],
      subjectFifthCtrl : [ ''],
      markFifthCtrl : [ '' ],
      markFifthOutCtrl : [ '' ],
      gradeFifthCtrl : [''],
      subjectSixthCtrl : [ '' ],
      markSixthCtrl : [ ''],
      markSixthOutCtrl : [ ''],
      gradeSixthCtrl : [''],
      subjectSeventhCtrl : [ ''],
      markSeventhCtrl : [ ''],
      markSeventhOutCtrl : [ ''],
      gradeSeventhCtrl : [''],
      subjectEighthCtrl : [ ''],
      markEighthCtrl : [ ''],
      markEighthOutCtrl: [ ''],
      gradeEighthCtrl :[''],
      subjectNinthCtrl : [ ''],
      markNinthCtrl : [ ''],
      markNinthOutCtrl: [ ''],
      gradeNinthCtrl :[''],
      subjectTenthCtrl : [ ''],
      markTenthCtrl : [ ''],
      markTenthOutCtrl: [ ''],
      gradeTenthCtrl :[''],
      instructionCtrl : [ '' ,  Validators.required],
      specialInstrctionCtrl: [ ''],
      finalgradespecialInstrctionCtrl: [ ''],
      totalweeksCtrl : [ ''],
      creditsEarnedCFirstCtrl : [ '' ,  Validators.required],
      creditsEarnedCSecondCtrl : [ '' ],
      creditsEarnedCThirdCtrl : [ '' ],
      creditsEarnedCFourthCtrl : [ '' ],
      creditsEarnedCFifthCtrl : [ ''],
      creditsEarnedCSixthCtrl : [ '' ],
      creditsEarnedCSevenCtrl : [ '' ],
      creditsEarnedCEightCtrl : [''],
      creditsEarnedCNinthCtrl : [ '' ],
      creditsEarnedCtenthCtrl : [ ''],
      gradepointsFirstCtrl : [ '' ,  Validators.required],
      gradecreditsFirstCtrl : [ '' ,  Validators.required],
      gradepointsSecondCtrl : [ '' ],
      gradecreditsSecondCtrl : [ '' ],
      gradepointsThirdCtrl : [ '' ],
      gradecreditsThirdCtrl : [ '' ],
      gradepointsFourthCtrl : [ '' ],
      gradecreditsFourthCtrl : [ '' ],
      gradepointsFifthCtrl : [ ''],
      gradecreditsFifthCtrl : [ ''],
      gradepointsSixthCtrl : [ ''],
      gradecreditsSixthCtrl : [ ''],
      gradepointsSeventhCtrl : [ ''],
      gradecreditsSeventhCtrl : [ ''],
      gradepointsEighthCtrl : [ ''],
      gradecreditsEighthCtrl : [ ''],
      gradepointsNinthCtrl : [ ''],
      gradecreditsNinthCtrl : [ ''],
      gradepointsTenthCtrl : [ ''],
      gradecreditsTenthCtrl : [ ''],
      overmarksobtCtrl : [ '' ],
      overmarksoutCtrl : [ '' ],
      internalMarksCtrl : [ ''],
      internalMarksSecondCtrl : [ '' ],
      internalMarksThirdCtrl : [ '' ],
      internalMarksFourthCtrl : [ '' ],
      internalMarksFifthCtrl : [ ''],
      internalMarksSixthCtrl : [ ''],
      internalMarksSeventhCtrl : [ ''],
      internalMarksEightCtrl : [ ''],
      internalMarksNineCtrl : [''],
      internalMarksTenCtrl : [''],
      pracFirstCtrl : [ '' ],
      pracSecondCtrl : [ '' ],
      pracThirdCtrl : [ '' ],
      pracFourthCtrl : [ '' ],
      pracFifthCtrl : [ ''],
      pracSixthCtrl : [ ''],
      pracSeventhCtrl : [ ''],
      pracEightCtrl : [ ''],
      pracNineCtrl : [''],
      pracTenCtrl : [''],
      FirstTotalCtrl : [ ''],
      SecondTotalCtrl : [''],
      ThirdTotalCtrl : [''],
      FourthTotalCtrl : [''],
      FifthTotalCtrl : [''],
      SixthTotalCtrl : [''],
      SeventhTotalCtrl : [''],
      EightTotalCtrl : [''],
      NineTotalCtrl : [''],
      TenTotalCtrl : [''],
      overAllTotalCtrl :[''],
      


      totalCCtrl : [ '' ,  Validators.required],
      totalCnGCtrl : [ '' ,  Validators.required],
      
      OverallCGPACtrl: [' '],//[Validators.pattern( "^[0-9]+(.[0-9]{0,2})?$")]
      finalGradeCtrl: [''],
      SpecialisationCtrl : [ '' ],
      startyearCtrl: [''],
      seatNumberCtrl: [ '' ,  Validators.required],
      remarksCtrl : [''],
      resultCtrl : [''],
      subjectEditFirstCtrl : [ '' ],
      subjectEditSecondCtrl : [ '' ],
      subjectEditThirdCtrl : [ '' ],
      subjectEditFourthCtrl : [ '' ],
      subjectEditFifthCtrl : [ '' ],
      subjectEditSixthCtrl : [ '' ],
      subjectEditSeventhCtrl : [ '' ],
      subjectEditEightCtrl : [ '' ],
      subjectEditNinthCtrl : [ '' ],
      subjectEditTenthCtrl : [ '' ],


      courseEdit1Ctrl : [''],
      courseEdit2Ctrl : [''],
      courseEdit3Ctrl : [''],
      courseEdit4Ctrl : [''],
      courseEdit5Ctrl : [''],
      courseEdit6Ctrl : [''],
      courseEdit7Ctrl : [''],
      courseEdit8Ctrl : [''],
      courseEdit9Ctrl : [''],
      courseEdit10Ctrl : [''],

      codePreFirstCtrl : [''],
      codePreSecondCtrl : [''],
      codePreThirdCtrl : [''],
      codePreFourthCtrl : [''],
      codePreFifthCtrl : [''],
      codePreSixthCtrl : [''],
      codePreSeventhCtrl : [''],
      codePreEightCtrl : [''],
      codePreNinthCtrl : [''],
      codePreTenthCtrl : [''],
      // footnotesCtrl : [''],
      sem1gpadetailsctrl: [''],
      sem2gpadetailsctrl: [''],
      sem3gpadetailsctrl: [''],
      sem4gpadetailsctrl: [''],
      sem5gpadetailsctrl: [''],
      footnotesCtrl : [''],
      sgpiInstCtrl : [''],

    })

    if(this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo'){
      this.college_year = 'First';
      if(this.college_year_auto == 'SemesterOne'){
        this.semester_auto = 'I';
      }else{
        this.semester_auto = 'II';
      }
    }else if(this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour'){
      this.college_year = 'Second';
      if(this.college_year_auto == 'SemesterThree'){
        this.semester_auto = 'III';
      }else{
        this.semester_auto = 'IV';
      }
    }else if(this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix'){
      this.college_year = 'Third';
      if(this.college_year_auto == 'SemesterFive'){
        this.semester_auto = 'V';
      }else{
        this.semester_auto = 'VI';
      }
    }

    this.api.getStillStudying(this.user_id)
    .subscribe(
      (data: any) => {
        
        if (data['status'] == 200) {
          this.still_studying = data['data'];
          
          
          this.stillStudy = this.still_studying.stillStudying;
          
        } else {

        }
      });

    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if(data['status'] == 200){
            this.course_data = data['data'];
            
            if(this.course_name_auto!=null){
              this.course_data.forEach(element => {
                if(element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto){
                  this.course_name = element.CourseShortForm;
                  this.edu_level = element.type;
                }
              });
            }
          }else{

          }
          this.api.getCouseCode('sem',this.course_name,this.semester_auto,this.sgpi_gpa).subscribe((data: any) => {
            if (data["status"] == 200) {
              
              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
                
              });
              
              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
                
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
                
              });
              
              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });

              
      
              
            } else {
            }
          });
          
         
    });

    this.api.getAllSpecialisation()
    .subscribe(
      (data: any) => {
        if (data['status'] == 200) {
          this.specialisation_data = data['data'];
          if (this.specialisationlevel_auto != null) {
            this.specialisation_data.forEach(element => {
              
              if (element.specialisation_name == this.specialisationlevel_auto) {
                this.specialisation_name = element.specialisation_name;
              }
            });
          }
          
        } else {

        }
      });

      this.api.getApplicantSpecialisation(this.course_name_auto)
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.applicant_specialisation = data['data'];
            
              this.applicant_specialisation.forEach(element => {
                
                // if (element.specialisation_name == this.specialisationlevel_auto) {
                //   this.specialisation_name = element.specialisation_name;
                // }
              });
            
            
          } else {
  
          }
        });

    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    
    for(let info of this.years_array){
      if(info >= this.enrollment_year_auto){
        this.enrollYear.push(info)
       }
    } this.getEduDetails()
  }
    
  
    getEduDetails(){
        
    
    if(this.user_id != null && this.edu_id != null){
      this.api.getEducation(this.edu_id,this.user_id)
      .subscribe(
        (data: any) => {
          
          if(data['status'] == 200){
            this.edu_data = data['data'];
            
            if(this.edu_data.special_instruction1){
              this.instruction1=true;
              this.special_instruction1 =this.edu_data.special_instruction1;
            }else{
              this.instruction1=false;
              this.special_instruction1 =null;
            }
            if(this.edu_data.special_instruction2){
              this.instruction2=true;
              this.special_instruction2 =this.edu_data.special_instruction2;
            }else{
              this.instruction2=false;
              this.special_instruction2 =null;
            }
            if(this.edu_data.special_instruction3){
              this.instruction3=true;
              this.special_instruction3 =this.edu_data.special_instruction3;
            }else{
              this.instruction3=false;
              this.special_instruction3 =null;
            } 
            if(this.edu_data.special_instruction4){
              this.instruction4=true;
              this.special_instruction4 =this.edu_data.special_instruction4;
            }else{
              this.instruction4=false;
              this.special_instruction4 =null;
            } 
            if(this.edu_data.special_instruction5){
              this.special_instruction5 =this.edu_data.special_instruction5;
              this.instruction5=true;
            }else{
              this.instruction5=false;
              this.special_instruction5 =null;
            } 
            if(this.edu_data.special_instruction6){
              this.instruction6=true;
              this.special_instruction6 =this.edu_data.special_instruction6;
            }else{
              this.instruction6=false;
              this.special_instruction6 =null;
            }  
            if(this.edu_data.special_instruction7){
              this.instruction7=true;
              this.special_instruction7 =this.edu_data.special_instruction7;
            }else{
              this.instruction7=false;
              this.special_instruction7 =null;
            }

            if(this.edu_data.startYear == ''){
              this.yearStart =this.yearStart
             }else{
              this.yearStart = this.edu_data.startYear
             }
            this.course_name = this.edu_data.CourseName;
            this.college_year = this.edu_data.CollegeYear;
            this.semester_auto = this.edu_data.Semester;
            this.enrollment_year = this.edu_data.Year;
            this.specialisation_name = this.edu_data.specialisation;
            if (
              this.edu_data.course_code_first != null &&
              this.edu_data.course_code_first != "" &&
              this.edu_data.course_code_first != undefined
            ) {
              this.showcodeDropdown = false;
              setTimeout(() => {
                
                this.course_code.forEach((element) => {
                  
                  if (element["Course_code"] == this.edu_data.course_code_first) {
                    this.subjectArray.push(element);
                  }
                });
              }, 3000);
              
            } else {
              
              this.showcodeDropdown = true;
            }
            if (this.edu_data.course_code_second != null) {
              this.showcodeDropdown2 = false;
              setTimeout(() => {
                this.course_code2.forEach((element) => {
                  if (element["Course_code"] == this.edu_data.course_code_second) {
                    this.subjectArray2.push(element);
                  }
                });
              }, 3000);
              
            } else {
              
              this.showcodeDropdown2 = true;
            }
            if (
              this.edu_data.course_code_third != null &&
              this.edu_data.course_code_third != "" &&
              this.edu_data.course_code_third != undefined
            ) {
              this.showcodeDropdown3 = false;
              
              setTimeout(() => {
                this.course_code3.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_third
                  ) {
                    this.subjectArray3.push(element);
                  }
                });
              }, 3000);
            } else {
              
              this.showcodeDropdown3 = true;
            }
            if (
              this.edu_data.course_code_fourth != null &&
              this.edu_data.course_code_fourth != "" &&
              this.edu_data.course_code_fourth != undefined
            ) {
              this.showcodeDropdown4 = false;
              
              setTimeout(() => {
                this.course_code4.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_fourth
                  ) {
                    this.subjectArray4.push(element);
                  }
                });
              }, 4000);
            } else {
              
              this.showcodeDropdown4 = true;
            }
            if (
              this.edu_data.course_code_fifth != null &&
              this.edu_data.course_code_fifth != "" &&
              this.edu_data.course_code_fifth != undefined
            ) {
              this.showcodeDropdown5 = false;
              
              setTimeout(() => {
                this.course_code5.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_fifth
                  ) {
                    this.subjectArray5.push(element);
                  }
                });
              }, 4000);
            } else {
              
              this.showcodeDropdown5 = true;
            }
            if (
              this.edu_data.course_code_sixth != null &&
              this.edu_data.course_code_sixth != "" &&
              this.edu_data.course_code_sixth != undefined
            ) {
              this.showcodeDropdown6 = false;
              
              setTimeout(() => {
                this.course_code6.forEach((element) => {
                  if (element["Course_code"] == this.edu_data.course_code_sixth) {
                    this.subjectArray6.push(element);
                  }
                });
              }, 4000);
            } else {
              
              this.showcodeDropdown6 = true;
            }
            if (
              this.edu_data.course_code_seventh != null &&
              this.edu_data.course_code_seventh != "" &&
              this.edu_data.course_code_seventh != undefined
            ) {
              this.showcodeDropdown7 = false;
              
              setTimeout(() => {
                this.course_code7.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_seventh
                  ) {
                    this.subjectArray7.push(element);
                  }
                });
              }, 4000);
            } else {
              
              this.showcodeDropdown7 = true;
            }
            if (
              this.edu_data.course_code_eight != null &&
              this.edu_data.course_code_eight != "" &&
              this.edu_data.course_code_eight != undefined
            ) {
              this.showcodeDropdown8 = false;
              setTimeout(() => {
                this.course_code8.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_eight
                  ) {
                    this.subjectArray8.push(element);
                  }
                });
              }, 5000);
              
            } else {
              
              this.showcodeDropdown8 = true;
            }
            if (
              this.edu_data.course_code_ninth != null &&
              this.edu_data.course_code_ninth != "" &&
              this.edu_data.course_code_ninth != undefined
            ) {
              this.showcodeDropdown9 = false;
              setTimeout(() => {
                this.course_code9.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_ninth
                  ) {
                    this.subjectArray9.push(element);
                  }
                });
              }, 4000);
              
            } else {
              
              this.showcodeDropdown9 = true;
            }
            if (
              this.edu_data.course_code_tenth != null &&
              this.edu_data.course_code_tenth != "" &&
              this.edu_data.course_code_tenth != undefined
            ) {
              this.showcodeDropdown10 = false;
              setTimeout(() => {
                this.course_code10.forEach((element) => {
                  if (
                    element["Course_code"] == this.edu_data.course_code_tenth
                  ) {
                    this.subjectArray10.push(element);
                  }
                });
              }, 4000);
              
            } else {
              
              this.showcodeDropdown10 = true;
            }
            if(this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined){
              this.showcodeDropdown = false
              
            }else{
              
              this.showcodeDropdown = true
            }
            if(this.edu_data.Subject_Second != null){
              this.showcodeDropdown2 = false
              
            }else{
              
              this.showcodeDropdown2 = true
            }
            if(this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined){
              this.showcodeDropdown3 = false
              
            }else{
              
              this.showcodeDropdown3 = true
            }
            if(this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined){
              this.showcodeDropdown4 = false
              
            }else{
              
              this.showcodeDropdown4 = true
            }
            if(this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined){
              this.showcodeDropdown5 = false
              
            }else{
              
              this.showcodeDropdown5 = true
            }
            if(this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined){
              this.showcodeDropdown6 = false
              
            }else{
              
              this.showcodeDropdown6 = true
            }
            if(this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined){
              this.showcodeDropdown7 = false
              
            }else{
              
              this.showcodeDropdown7 = true
            }
            if(this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined){
              this.showcodeDropdown8 = false
              
            }else{
              
              this.showcodeDropdown8 = true
            }

            if(this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined){
              this.showcodeDropdown9 = false
              
            }else{
              
              this.showcodeDropdown9 = true
            }
            if(this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined){
              this.showcodeDropdown10 = false
              
            }else{
              
              this.showcodeDropdown10 = true
            }
            
          }else{
            
          }
      });
    }else{
      
    }
  }

  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value;
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray.push(element);
      }
      count++;
      if (element["id"] == this.subjectName["id"]) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code;
      }
    });
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value;
    for (let a of this.course_code2) {
      
      if (a.Course_code == this.withoutCodeSub) {
        
        this.subjectName = a;
      }
    }
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value;
    this.course_code2.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray2.push(element);
      }
    });
    
    var count = 0;
    this.newcourse_code = [];
    this.course_code3.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code;
      }
    });
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value;
    for (let a of this.course_code) {
      
      if (a.Course_code == this.withoutCodeSub2) {
        
        this.subjectName2 = a;
      }
    }
  }

  getCourse3(value) {
    this.subjectName3 = value;
    this.course_code3.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray3.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code4.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code;
      }
    });
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value;
    for (let a of this.course_code3) {
      
      if (a.Course_code == this.withoutCodeSub3) {
        this.subjectName3 = a;
      }
    }
  }

  getCourse4(value) {
    this.subjectName4 = value;
    this.course_code4.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray4.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code5.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code;
      }
    });
  }

  getSubject4(event: any) {
    
    this.withoutCodeSub4 = event.target.value;
    for (let a of this.course_code4) {
      
      if (a.Course_code == this.withoutCodeSub4) {
        
        this.subjectName4 = a;
      }
    }
  }

  getCourse5(value) {
    this.subjectName5 = value;
    this.course_code5.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray5.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code6.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code;
      }
    });
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value;
    for (let a of this.course_code5) {
      
      if (a.Course_code == this.withoutCodeSub5) {
        
        this.subjectName5 = a;
      }
    }
  }

  getCourse6(value) {
    this.subjectName6 = value;
    this.course_code6.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray6.push(element);
      }
    });
   
      

    var count = 0;
    this.newcourse_code = [];
    this.course_code7.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code;
      }
    });
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value;
    for (let a of this.course_code6) {
      
      if (a.Course_code == this.withoutCodeSub6) {
        
        this.subjectName6 = a;
      }
    }
  }

  getCourse7(value) {
    this.subjectName7 = value;
    this.course_code7.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray7.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code8.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"] ||
        element["id"] == this.subjectName7["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code;
      }
    });
  }

  getSubject8(event: any) {
    
    this.withoutCodeSub8 = event.target.value;
    for (let a of this.course_code8) {
      
      if (a.Course_code == this.withoutCodeSub8) {
        
        this.subjectName8 = a;
      }
    }
  }
  getCourse8(value) {
    this.subjectName8 = value;
    this.course_code8.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray8.push(element);
      }
    });
    
  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value;
    for (let a of this.course_code9) {
      
      if (a.Course_code == this.withoutCodeSub9) {
        
        this.subjectName9 = a;
      }
    }
  }
  getCourse10(value) {
    this.subjectName10 = value;
    this.course_code10.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray10.push(element);
      }
    });
    
  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value;
    for (let a of this.course_code10) {
      
      if (a.Course_code == this.withoutCodeSub10) {
        
        this.subjectName10 = a;
      }
    }
  }
  getCourse9(value) {
    this.subjectName9 = value;
    this.course_code9.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray9.push(element);
      }
    });
    
  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value;
    for (let a of this.course_code7) {
      
      if (a.Course_code == this.withoutCodeSub7) {
        
        this.subjectName7 = a;
      }
    }
  }

  // getCourse(value){
  
  //   ///this.filterText = "";
  //   this.subjectName = value
  

  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code.forEach(element => {
  //     count++
  //     if(element['id'] == this.subjectName['id']){
  
  //     }else{
  
  //       this.newcourse_code.push(element)

  //     }

  //     if(count == this.course_code.length){
  //       this.course_code = this.newcourse_code
  //     }
  //   })
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour1 = value.Lec_per_Week
  //   //   this.lec_per_week1 = '-'
  //   // }else{
  //   //   this.lec_per_week1 = value.Lec_per_Week
  //   //   this.prac_hour1 = '-'
  
  //   // }
  //   //this.filterPlaceholder = "Search";
  //   // this.adminApi.getAllCourse(value).subscribe((data)=>{
  //   //   this.courses = data['data'];
  //   // })
  //   // this.filterInput
  //   //   .valueChanges
  //   //   .debounceTime(200)
  //   //   .subscribe(term => {
  //   //   this.filterText = term;
  //   // });
  // }

  // // getSubject(event : any){
  
  // //   this.withoutCodeSub = event.target.value
  // //   if(this.subjectName){
  
  // //   }else{
  
  // //   }
  // // }

  // getCourse2(value){
  
  //   //this.filterText = "";
  //   this.subjectName2 = value
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code3.forEach(element => {
  //     count++
  //     if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']){
  
  //     }else{
  
  //       this.newcourse_code.push(element)

  //     }

  //     if(count == this.course_code3.length){
  //       this.course_code3 = [];
  //       this.course_code3 = this.newcourse_code
  //     }
  //   })
  // }

  // // getSubject2(event : any){
  
  // //   this.withoutCodeSub2 = event.target.value
   
  // // }

  // // getCourse(value) {
  
  // //   //this.filterText = "";
  // //   this.subjectName = value;
  // //   var count = 0;
  // //   this.newcourse_code = [];
  // //   this.course_code.forEach((element) => {
  // //     if (element["Course_code"] == value["Course_code"]) {
  // //       this.subjectArray.push(element);
        
  // //     }
  // //     count++;
  // //     if (element["id"] == this.subjectName["id"]) {
  // 
  // //     } else {
  // 
  // //       this.newcourse_code.push(element);
  // //     }

  // //     if (count == this.course_code.length) {
  // //       this.course_code = this.newcourse_code;
  // //     }
  // //   });
  
  // // }

  // getSubject(event: any) {
  
  //   this.withoutCodeSub = event.target.value;
  //   for (let a of this.course_code2) {
  
  //     if (a.Course_Code == this.withoutCodeSub) {
  
  //       this.subjectName = a;
  //     }
  //   }
  //   if (this.subjectName) {
  
  //   } else {
  
  //   }
  // }

  // // getCourse2(value) {
  
  // //   //this.filterText = "";
  // //   this.subjectName2 = value;
  // //   this.course_code2.forEach((element) => {
  // //     if (element["Course_code"] == value["Course_code"]) {
  // //       this.subjectArray2.push(element);
  // //     }
  // //   });
    

  // //   var count = 0;
  // //   this.newcourse_code = [];
  // //   this.course_code3.forEach((element) => {
  // //     count++;
  // //     if (
  // //       element["id"] == this.subjectName["id"] ||
  // //       element["id"] == this.subjectName2["id"]
  // //     ) {
  // 
  // //     } else {
  // 
  // //       this.newcourse_code.push(element);

  // //     }

  // //     if (count == this.course_code3.length) {
  // //       this.course_code3 = [];
  // //       this.course_code3 = this.newcourse_code;
  // //     }
  // //   });
  // // }

  // getSubject2(event: any) {
  
  //   this.withoutCodeSub2 = event.target.value;
  //   for (let a of this.course_code) {
  
  //     if (a.Course_Code == this.withoutCodeSub2) {
  
  //       this.subjectName2 = a;
  //     }
  //   }
  // }

  // getCourse3(value) {
  
  //   this.subjectName3 = value;
  //   this.course_code3.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray3.push(element);
  //     }
  //   });
   

  //   var count = 0;
  //   this.newcourse_code = [];
  //   this.course_code4.forEach((element) => {
  //     count++;
  //     if (
  //       element["id"] == this.subjectName["id"] ||
  //       element["id"] == this.subjectName2["id"] ||
  //       element["id"] == this.subjectName3["id"]
  //     ) {
  
  //     } else {
  
  //       this.newcourse_code.push(element);

  
  //     }

  //     if (count == this.course_code4.length) {
  //       this.course_code4 = [];
  //       this.course_code4 = this.newcourse_code;
  //     }
  //   });
  // }

  // getSubject3(event: any) {
  //   this.withoutCodeSub3 = event.target.value;
  //   for (let a of this.course_code3) {
  
  //     if (a.Course_Code == this.withoutCodeSub3) {
  
  //       this.subjectName3 = a;
  //     }
  //   }
  // }

  // getCourse4(value) {
  //   this.subjectName4 = value;
  //   this.course_code4.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray4.push(element);
  //     }
  //   });
    

  //   var count = 0;
  //   this.newcourse_code = [];
  //   this.course_code5.forEach((element) => {
  //     count++;
  //     if (
  //       element["id"] == this.subjectName["id"] ||
  //       element["id"] == this.subjectName2["id"] ||
  //       element["id"] == this.subjectName3["id"] ||
  //       element["id"] == this.subjectName4["id"]
  //     ) {
  //     } else {
  //       this.newcourse_code.push(element);

  
  //     }

  //     if (count == this.course_code5.length) {
  //       this.course_code5 = [];
  //       this.course_code5 = this.newcourse_code;
  //     }
  //   });
  // }

  // getSubject4(event: any) {
  
  //   this.withoutCodeSub4 = event.target.value;
  //   for (let a of this.course_code4) {
  
  //     if (a.Course_Code == this.withoutCodeSub4) {
  
  //       this.subjectName4 = a;
  //     }
  //   }
  // }

  // getCourse5(value) {
  //   this.subjectName5 = value;
  //   this.course_code5.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray5.push(element);
  //     }
  //   });
   

  //   var count = 0;
  //   this.newcourse_code = [];
  //   this.course_code6.forEach((element) => {
  //     count++;
  //     if (
  //       element["id"] == this.subjectName["id"] ||
  //       element["id"] == this.subjectName2["id"] ||
  //       element["id"] == this.subjectName3["id"] ||
  //       element["id"] == this.subjectName4["id"] ||
  //       element["id"] == this.subjectName5["id"]
  //     ) {
  //     } else {
  //       this.newcourse_code.push(element);

  
  //     }

  //     if (count == this.course_code6.length) {
  //       this.course_code6 = [];
  //       this.course_code6 = this.newcourse_code;
  //     }
  //   });
  // }

  // getSubject5(event: any) {
  
  //   this.withoutCodeSub5 = event.target.value;
  //   for (let a of this.course_code5) {
  
  //     if (a.Course_Code == this.withoutCodeSub5) {
  
  //       this.subjectName5 = a;
  //     }
  //   }
  // }

  // getCourse6(value) {
  //   this.subjectName6 = value;
  //   this.course_code6.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray6.push(element);
  //     }
  //   });
    

  //   var count = 0;
  //   this.newcourse_code = [];
  //   this.course_code7.forEach((element) => {
  //     count++;
  //     if (
  //       element["id"] == this.subjectName["id"] ||
  //       element["id"] == this.subjectName2["id"] ||
  //       element["id"] == this.subjectName3["id"] ||
  //       element["id"] == this.subjectName4["id"] ||
  //       element["id"] == this.subjectName5["id"] ||
  //       element["id"] == this.subjectName6["id"]
  //     ) {
  //     } else {
  //       this.newcourse_code.push(element);

  
  //     }

  //     if (count == this.course_code7.length) {
  //       this.course_code7 = [];
  //       this.course_code7 = this.newcourse_code;
  //     }
  //   });
  // }

  // getSubject6(event: any) {
  
  //   this.withoutCodeSub6 = event.target.value;
  //   for (let a of this.course_code6) {
  
  //     if (a.Course_Code == this.withoutCodeSub6) {
  
  //       this.subjectName6 = a;
  //     }
  //   }
  // }

  // getCourse7(value) {
  //   this.subjectName7 = value;
  //   this.course_code7.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray7.push(element);
  //     }
  //   });
    

  //   var count = 0;
  //   this.newcourse_code = [];
  //   this.course_code8.forEach((element) => {
  //     count++;
  //     if (
  //       element["id"] == this.subjectName["id"] ||
  //       element["id"] == this.subjectName2["id"] ||
  //       element["id"] == this.subjectName3["id"] ||
  //       element["id"] == this.subjectName4["id"] ||
  //       element["id"] == this.subjectName5["id"] ||
  //       element["id"] == this.subjectName6["id"] ||
  //       element["id"] == this.subjectName7["id"]
  //     ) {
  //     } else {
  //       this.newcourse_code.push(element);

  
  //     }

  //     if (count == this.course_code8.length) {
  //       this.course_code8 = [];
  //       this.course_code8 = this.newcourse_code;
  //     }
  //   });
  // }

  // getSubject8(event: any) {
  
  //   this.withoutCodeSub8 = event.target.value;
  //   for (let a of this.course_code8) {
  
  //     if (a.Course_Code == this.withoutCodeSub8) {
  
  //       this.subjectName8 = a;
  //     }
  //   }
  // }
  // getCourse8(value) {
  //   this.subjectName8 = value;
  //   this.course_code8.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray8.push(element);
  //     }
  //   });
    
  // }
  // getSubject9(event: any) {
  
  //   this.withoutCodeSub9 = event.target.value;
  //   for (let a of this.course_code9) {
  
  //     if (a.Course_Code == this.withoutCodeSub9) {
  
  //       this.subjectName9 = a;
  //     }
  //   }
  // }
  // getCourse10(value) {
  //   this.subjectName10 = value;
  //   this.course_code10.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray10.push(element);
  //     }
  //   });
    
  // }

  // getSubject10(event: any) {
  
  //   this.withoutCodeSub10 = event.target.value;
  //   for (let a of this.course_code10) {
  
  //     if (a.Course_Code == this.withoutCodeSub10) {
  
  //       this.subjectName10 = a;
  //     }
  //   }
  // }
  // getCourse9(value) {
  //   this.subjectName9 = value;
  //   this.course_code9.forEach((element) => {
  //     if (element["Course_code"] == value["Course_code"]) {
  //       this.subjectArray9.push(element);
  //     }
  //   });
   
  // }

  // getSubject7(event: any) {
  
  //   this.withoutCodeSub7 = event.target.value;
  //   for (let a of this.course_code7) {
  
  //     if (a.Course_Code == this.withoutCodeSub7) {
  
  //       this.subjectName7 = a;
  //     }
  //   }
  // }
  changeValue(value:any){
    
    if(value){
      this.api.getPredictiveCourse('sem',this.course_name_auto, this.semester_auto, value, this.college_year,this.specialisationlevel_auto).
      subscribe((data : any)=>{
        
        if(data['status'] == 200){
          this.predictive_data = data['data'];
          
            this.predictive_data.forEach(element => {
             
              this.subjectPreName = element.Subject_First;
              this.subjectPreName2 = element.Subject_Second;
              this.subjectPreName3 = element.Subject_Third
              this.subjectPreName4 = element.Subject_Fourth;
              this.subjectPreName5 = element.Subject_Fifth;
              this.subjectPreName6 = element.Subject_Six
              this.subjectPreName7 = element.Subject_Seventh;
              this.subjectPreName8 = element.Subject_Eighth;
              this.subjectPreName9 = element.Subject_Ninth;
              this.subjectPreName10 = element.Subject_Tenth;

              this.courseCodePreName = element.course_code_first;
              this.courseCodePreName2 = element.course_code_second;
              this.courseCodePreName3 = element.course_code_third;
              this.courseCodePreName4 = element.course_code_fourth;
              this.courseCodePreName5 = element.course_code_fifth;
              this.courseCodePreName6 = element.course_code_sixth;
              this.courseCodePreName7 = element.course_code_seventh;
              this.courseCodePreName8 = element.course_code_eight;
              this.courseCodePreName9 = element.course_code_ninth;
              this.courseCodePreName10 = element.course_code_tenth;

              this.crerditsPre1 = element.credits_Earned_c_First;
              this.crerditsPre2 = element.credits_Earned_c_Second;
              this.crerditsPre3 = element.credits_Earned_c_Third;
              this.crerditsPre4 = element.credits_Earned_c_Fourth;
              this.crerditsPre5 = element.credits_Earned_c_Fifth;
              this.crerditsPre6 = element.credits_Earned_c_Sixth;
              this.crerditsPre7 = element.credits_Earned_c_Seven;
              this.crerditsPre8 = element.credits_Earned_c_Eight;
              this.crerditsPre9 = element.credits_Earned_c_Ninth;
              this.crerditsPre10 = element.credits_Earned_c_ten;
             
              
              
                  if(value == element.Year){
                  this.show_predictive = true;
                   
              }
            });
         
        }
          else{
            this.show_predictive = false;
                    
                    this.api.getCouseCodeNew('sem',this.course_name_auto, this.semester_auto, this.specialisationlevel_auto,this.college_year, this.sgpi_gpa)
                    .subscribe(
                      (data: any) => {
                        if (data['status'] == 200) {
                          this.autocheck = false
                          this.filterText = "";
                          this.course_code = data['data'];
                          
                          this.filterInput
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText =   term;
               
                            });
                            this.course_code2 = data['data']
                            this.filterInput2
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText2 =   term;
               
                            });
               
                            this.course_code3 = data['data']
                            this.filterInput3
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText3 =   term;
               
                            });
                            this.course_code4 = data['data']
                            this.filterInput4
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText4 =   term;
               
                            });
                            this.course_code5 = data['data']
                            this.filterInput5
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText5 =   term;
               
                            });
                            this.course_code6 = data['data']
                            this.filterInput6
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText6 =   term;
               
                            });
                            this.course_code7 = data['data']
                            this.filterInput7
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText7 =   term;
               
                            });
                            this.course_code8 = data['data']
                            this.filterInput8
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText8 =   term;
               
                            });
                            this.course_code9 = data['data']
                            this.filterInput9
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText9 =   term;
               
                            });
                            this.course_code10 = data['data']
                            this.filterInput10
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText10 =   term;
               
                            });
                        }        
          })
      }
    });  
  }
}
editDropdown(){
  this.showcodeDropdown = true
  this.preEditFirst = true;
  this.editShow1 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
.subscribe(
  (data: any) => {
    
    if(data['status'] == 200){
     // this.autocheck = false
      this.course_code2 = data['data']
      this.filterText2 = "";
        this.filterInput2
        .valueChanges
        .debounceTime(200)
        .subscribe(term => {
        this.filterText2 = term;
        //this.filterText2 = term;
      });
     
   
      
    }else{

    }
});
}

editDropdown2(){
  
  
  this.showcodeDropdown2 = true
  this.preEditSecond = true;
  this.editShow2 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText = "";
        this.course_code = info['data'];
       
        this.filterInput
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText = term;
        });
        
      }else{

      }
});
}

editDropdown3(){
  this.showcodeDropdown3 = true
  this.preEditThird = true;
  this.editShow3 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText3 = "";
        this.course_code3 = info['data'];
       
        this.filterInput3
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText3 = term;
        });
        
      }else{

      }
});
}

editDropdown4(){
  this.showcodeDropdown4 = true
  this.preEditFourth = true;
  this.editShow4 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText4 = "";
        this.course_code4 = info['data'];
       
        this.filterInput3
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText4 = term;
        });
        
      }else{

      }
});
}

editDropdown5(){
  this.showcodeDropdown5 = true
  this.preEditFifth = true;
  this.editShow5 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText5 = "";
        this.course_code5 = info['data'];
       
        this.filterInput5
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText5 = term;
        });
        
      }else{

      }
});
}

editDropdown6(){
  this.showcodeDropdown6 = true
  this.preEditSixth = true;
  this.editShow6 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText6 = "";
        this.course_code6 = info['data'];
       
        this.filterInput6
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText6 = term;
        });
        
      }else{

      }
});
}

editDropdown7(){
  this.showcodeDropdown7 = true
  this.preEditSeventh = true;
  this.editShow7 = true
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText7 = "";
        this.course_code7 = info['data'];
       
        this.filterInput7
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText7 = term;
        });
        
      }else{

      }
});
}

editDropdown8(){
  this.showcodeDropdown8 = true
  this.preEditEight = true;
  this.editShow8 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText8 = "";
        this.course_code8 = info['data'];
       
        this.filterInput8
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText8 = term;
        });
        
      }else{

      }
});
}

editDropdown9(){
  this.showcodeDropdown9 = true
  this.preEditNinth = true;
  this.editShow9 = true;
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText9 = "";
        this.course_code9 = info['data'];
       
        this.filterInput9
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText9 = term;
        });
        
      }else{

      }
});
}

editDropdown10(){
  this.preEditTenth = true;
  this.showcodeDropdown10 = true
  this.editShow10 = true
  this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (info: any) => {
      
      if(info['status'] == 200){
        this.autocheck = false
        this.filterText10 = "";
        this.course_code10 = info['data'];
       
        this.filterInput10
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          //this.filterText = term;
          this.filterText10 = term;
        });
        
      }else{

      }
});
}

setSubject1value(value){
  this.edu_form.controls.subjectFirstCtrl.setValue(value)
}
setSubject2value(value){
  this.edu_form.controls.subjectSecondCtrl.setValue(value)
}
setSubject3value(value){
  this.edu_form.controls.subjectThirdCtrl.setValue(value)
}
setSubject4value(value){
  this.edu_form.controls.subjectFourthCtrl.setValue(value)
}
setSubject5value(value){
  this.edu_form.controls.subjectFifthCtrl.setValue(value)
}

setSubject6value(value){
  this.edu_form.controls.subjectSixthCtrl.setValue(value)
}

setSubject7value(value){
  this.edu_form.controls.subjectSeventhCtrl.setValue(value)
}

setSubject8value(value){
  this.edu_form.controls.subjectEighthCtrl.setValue(value)
}

setSubject9value(value){
  this.edu_form.controls.subjectNinthCtrl.setValue(value)
}

setSubject10value(value){
  this.edu_form.controls.subjectTenthCtrl.setValue(value)
}

 
  showContactDetails(){
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;'+' Whatsapp -  +91 99306 00066'  ,
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
               
      },
      reject: () => {
       
      }
    });
  }

 

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.endYearValidation = true;

    if(this.edu_form.controls.semesterCtrl.value){
      if(this.edu_form.controls.endmonthCtrl.value){
        this.startmonth = this.edu_form.controls.endmonthCtrl.value
      }else{
        if(this.edu_form.controls.semesterCtrl.value == 'I' || this.edu_form.controls.semesterCtrl.value ==  'III' || this.edu_form.controls.semesterCtrl.value == 'V'){
          this.startmonth = 'June'
        }else{
          this.startmonth =  'November'
        }
      }
     
    }

    if (this.edu_form.valid==false){
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      // this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.pracFirstCtrl.markAsDirty();
      //this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      //this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      //this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.creditsEarnedCFirstCtrl.markAsDirty();
      // this.edu_form.controls.creditsEarnedCSecondCtrl.markAsDirty();
      // this.edu_form.controls.creditsEarnedCThirdCtrl.markAsDirty();
      // this.edu_form.controls.creditsEarnedCFourthCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFirstCtrl.markAsDirty();
      this.edu_form.controls.seatNumberCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsFourthCtrl.markAsDirty();
      this.edu_form.controls.totalCCtrl.markAsDirty();
      this.edu_form.controls.totalCnGCtrl.markAsDirty();

      if(this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value ==='' || this.edu_form.controls.instructionCtrl.value ===undefined){
        this.instructionValidation = false;
      }else {
        this.instructionValidation = true;
      }

      if(this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value ==='' || this.edu_form.controls.courseNameCtrl.value ===undefined){
        this.courseValidation = false;
      }else {
        this.courseValidation = true;
      }
     
      if(this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value ==='' || this.edu_form.controls.collegeYearCtrl.value ===undefined){
        this.collegeYearValidation = false;
      }else {
        this.collegeYearValidation = true;
      }

      if(this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value ==='' || this.edu_form.controls.semesterCtrl.value ===undefined){
        this.semesterValidation = false;
      }else {
        this.semesterValidation = true;
      }

      if(this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value ==='' || this.edu_form.controls.monthCtrl.value ===undefined){
        this.monthValidation = false;
      }else {
        this.monthValidation = true;
      }

      if(this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value ==='' || this.edu_form.controls.yearCtrl.value ===undefined){
        this.yearValidation = false;
      }else {
        this.yearValidation = true;
      }

      // if(this.edu_form.controls.endmonthCtrl.value === null || this.edu_form.controls.endmonthCtrl.value ==='' || this.edu_form.controls.endmonthCtrl.value ===undefined){
      //   this.endmonthValidation = false;
      // }else {
      //   this.endmonthValidation = true;
      // }

      // if(this.edu_form.controls.endyearCtrl.value === null || this.edu_form.controls.endyearCtrl.value ==='' || this.edu_form.controls.endyearCtrl.value ===undefined){
      //   this.endYearValidation = false;
      // }else {
      //   this.endYearValidation = true;
      // }

    }else{
      var edu_data ={
        courseName : this.edu_form.controls.courseNameCtrl.value,
        collegeYear : this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month : this.edu_form.controls.monthCtrl.value,
        year : this.edu_form.controls.yearCtrl.value,
        endmonth : this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
        endYear : this.edu_form.controls.endyearCtrl.value,
        overAllGrade : this.edu_form.controls.overAllGradeCtrl.value.toUpperCase(),
        overall_gpa_sgpi : this.edu_form.controls.overAllgpasgpiCtrl.value,
        subjectFirst : this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        // subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        // subjectSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectPreFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First : this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.totalValue ? this.totalValue : this.edu_form.controls.markFirstOutCtrl.value,
        markFirst : this.edu_form.controls.gradeFirstCtrl.value,
        subjectSecond : this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        subjectPreSecond : this.edu_form.controls.subjectSecondCtrl.value,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.totalValue2 ? this.totalValue2 : this.edu_form.controls.markSecondOutCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value,
        subjectThird : this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        subjectPreThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third : this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third : this.totalValue3 ?  this.totalValue3 : this.edu_form.controls.markThirdOutCtrl.value,
        markThird : this.edu_form.controls.gradeThirdCtrl.value,
        subjectPreFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth : this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth : this.totalValue4 ? this.totalValue4 : this.edu_form.controls.markFourthOutCtrl.value,
        markFourth : this.edu_form.controls.gradeFourthCtrl.value,
        subjectFourth : this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        subjectPreFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth : this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth : this.totalValue5 ? this.totalValue5 : this.edu_form.controls.markFifthOutCtrl.value,
        markFifth : this.edu_form.controls.gradeFifthCtrl.value,
        subjectFifth : this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        subjectSixth :this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        subjectPreSixth : this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six : this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six : this.totalValue6 ? this.totalValue6 :this.edu_form.controls.markSixthOutCtrl.value,
        markSixth : this.edu_form.controls.gradeSixthCtrl.value,
        subjectSeventh :this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        subjectPreSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh : this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh : this.totalValue7 ? this.totalValue7 : this.edu_form.controls.markSeventhOutCtrl.value,
        markSeventh : this.edu_form.controls.gradeSeventhCtrl.value,
        subjectEighth :  this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        subjectPreEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth : this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth : this.totalValue8 ? this.totalValue8 : this.edu_form.controls.markEighthOutCtrl.value,
        markEighth : this.edu_form.controls.gradeEighthCtrl.value,
        subjectNinth : this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        subjectPreNinth : this.edu_form.controls.subjectNinthCtrl.value,
        marks_obt_Ninth : this.edu_form.controls.markNinthCtrl.value,
        marks_out_Ninth : this.totalValue9 ? this.totalValue9 : this.edu_form.controls.markNinthOutCtrl.value,
        markNinth : this.edu_form.controls.gradeNinthCtrl.value,
        subjectTenth : this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        subjectPreTenth : this.edu_form.controls.subjectTenthCtrl.value,
        marks_obt_Tenth : this.edu_form.controls.markTenthCtrl.value,
        marks_out_Tenth : this.totalValue10 ? this.totalValue10 : this.edu_form.controls.markTenthOutCtrl.value,
        markTenth : this.edu_form.controls.gradeTenthCtrl.value,
        user_id : this.user_id,
        medium_instruction : this.edu_form.controls.instructionCtrl.value,
        id : this.edu_id,
        total_weeks : this.edu_form.controls.SpecialisationCtrl.value,
        special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        final_grade_special_instruction: this.GradespecialInstruction ? this.GradespecialInstruction : this.DradespecI,
        result : this.edu_form.controls.resultCtrl.value,
        remarks : this.edu_form.controls.remarksCtrl.value,
        overall_marks_obt : this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out : this.edu_form.controls.overmarksoutCtrl.value,
        grade_points_First  : this.edu_form.controls.gradepointsFirstCtrl.value,
        grade_credits_First  : this.edu_form.controls.gradecreditsFirstCtrl.value,
        grade_points_Second  : this.edu_form.controls.gradepointsSecondCtrl.value,
        grade_credits_Second  : this.edu_form.controls.gradecreditsSecondCtrl.value,
        grade_points_Third  : this.edu_form.controls.gradepointsThirdCtrl.value,
        grade_credits_Third  : this.edu_form.controls.gradecreditsThirdCtrl.value,
        grade_points_Fourth  : this.edu_form.controls.gradepointsFourthCtrl.value,
        grade_credits_Fourth  : this.edu_form.controls.gradecreditsFourthCtrl.value,
        grade_points_Fifth  : this.edu_form.controls.gradepointsFifthCtrl.value,
        grade_credits_Fifth  : this.edu_form.controls.gradecreditsFifthCtrl.value,
        grade_points_Six  : this.edu_form.controls.gradepointsSixthCtrl.value,
        grade_credits_Six  : this.edu_form.controls.gradecreditsSixthCtrl.value,
        grade_points_Seventh  : this.edu_form.controls.gradepointsSeventhCtrl.value,
        grade_credits_Seventh  : this.edu_form.controls.gradecreditsSeventhCtrl.value,
        grade_points_Eighth  : this.edu_form.controls.gradepointsEighthCtrl.value,
        grade_credits_Eighth  : this.edu_form.controls.gradecreditsEighthCtrl.value,
        grade_points_Ninth  : this.edu_form.controls.gradepointsNinthCtrl.value,
        grade_credits_Ninth  : this.edu_form.controls.gradecreditsNinthCtrl.value,
        grade_points_Tenth  : this.edu_form.controls.gradepointsTenthCtrl.value,
        grade_credits_Tenth  : this.edu_form.controls.gradecreditsTenthCtrl.value,
       
        internal_Marks : this.edu_form.controls.internalMarksCtrl.value.toUpperCase(),
        internal_Marks_Second : this.edu_form.controls.internalMarksSecondCtrl.value.toUpperCase(),
        internal_Marks_Third : this.edu_form.controls.internalMarksThirdCtrl.value.toUpperCase(),
        internal_Marks_Fourth : this.edu_form.controls.internalMarksFourthCtrl.value.toUpperCase(),
        internal_Marks_Fifth : this.edu_form.controls.internalMarksFifthCtrl.value.toUpperCase(),
        internal_Marks_Sixth : this.edu_form.controls.internalMarksSixthCtrl.value.toUpperCase(),
        internal_Marks_Seventh : this.edu_form.controls.internalMarksSeventhCtrl.value.toUpperCase(),
        internal_Marks_Eight : this.edu_form.controls.internalMarksEightCtrl.value.toUpperCase(),
        internal_Marks_Nine : this.edu_form.controls.internalMarksNineCtrl.value.toUpperCase(),
        internal_Marks_Ten : this.edu_form.controls.internalMarksTenCtrl.value.toUpperCase(),
        totalC : this.edu_form.controls.totalCCtrl.value,
        totalCnG : this.edu_form.controls.totalCnGCtrl.value,
        credits_Earned_c_First : this.edu_form.controls.creditsEarnedCFirstCtrl.value.toUpperCase(),
        credits_Earned_c_Second : this.edu_form.controls.creditsEarnedCSecondCtrl.value.toUpperCase(),
        credits_Earned_c_Third : this.edu_form.controls.creditsEarnedCThirdCtrl.value.toUpperCase(),
        credits_Earned_c_Fourth : this.edu_form.controls.creditsEarnedCFourthCtrl.value.toUpperCase(),
        credits_Earned_c_Fifth : this.edu_form.controls.creditsEarnedCFifthCtrl.value.toUpperCase(),
        credits_Earned_c_Sixth : this.edu_form.controls.creditsEarnedCSixthCtrl.value.toUpperCase(),
        credits_Earned_c_Seven : this.edu_form.controls.creditsEarnedCSevenCtrl.value.toUpperCase(),
        credits_Earned_c_Eight : this.edu_form.controls.creditsEarnedCEightCtrl.value.toUpperCase(),
        credits_Earned_c_Ninth : this.edu_form.controls.creditsEarnedCNinthCtrl.value.toUpperCase(),
        credits_Earned_c_tenth : this.edu_form.controls.creditsEarnedCtenthCtrl.value.toUpperCase(),

        practical_marks_first : this.edu_form.controls.pracFirstCtrl.value,
        practical_marks_Second : this.edu_form.controls.pracSecondCtrl.value,
        practical_marks_Third : this.edu_form.controls.pracThirdCtrl.value,
        practical_marks_Fourth : this.edu_form.controls.pracFourthCtrl.value,
        practical_marks_Fifth : this.edu_form.controls.pracFifthCtrl.value,
        practical_marks_Sixth : this.edu_form.controls.pracSixthCtrl.value,
        practical_marks_Seventh : this.edu_form.controls.pracSeventhCtrl.value,
        practical_marks_Eight : this.edu_form.controls.pracEightCtrl.value,
        practical_marks_Nine : this.edu_form.controls.pracNineCtrl.value,
        practical_marks_Ten : this.edu_form.controls.pracTenCtrl.value,

        first_total_marks : this.edu_form.controls.FirstTotalCtrl.value,
        second_total_marks : this.edu_form.controls.SecondTotalCtrl.value,
        third_total_marks : this.edu_form.controls.ThirdTotalCtrl.value,
        fourth_total_marks : this.edu_form.controls.FourthTotalCtrl.value,
        fifth_total_marks : this.edu_form.controls.FifthTotalCtrl.value,
        sixth_total_marks : this.edu_form.controls.SixthTotalCtrl.value,
        seventh_total_marks : this.edu_form.controls.SeventhTotalCtrl.value,
        eight_total_marks : this.edu_form.controls.EightTotalCtrl.value,
        nine_total_marks : this.edu_form.controls.NineTotalCtrl.value,
        ten_total_marks : this.edu_form.controls.TenTotalCtrl.value,

        over_all_total : this.edu_form.controls.overAllTotalCtrl.value,
        overall_CGPA  : this.edu_form.controls.OverallCGPACtrl.value,
        overAllYearlyGrade  : this.edu_form.controls.finalGradeCtrl.value,
        specialisation : this.edu_form.controls.SpecialisationCtrl.value,
        seat_number : this.edu_form.controls.seatNumberCtrl.value,

        special_instruction1 : this.special_instruction1,
        special_instruction2 : this.special_instruction2,
        special_instruction3 : this.special_instruction3,
        special_instruction4 : this.special_instruction4,
        special_instruction5 : this.special_instruction5,
        special_instruction6 : this.special_instruction6,
        special_instruction7 : this.special_instruction7,
        
        course_code_first: this.subjectName
          ? this.subjectName["Course_code"]
          : this.withoutCodeSub,
        course_code_second: this.subjectName2
          ? this.subjectName2["Course_code"]
          : this.withoutCodeSub2,
        course_code_third: this.subjectName3
          ? this.subjectName3["Course_code"]
          : this.withoutCodeSub3,
        course_code_fourth: this.subjectName4
          ? this.subjectName4["Course_code"]
          : this.withoutCodeSub4,
        course_code_fifth: this.subjectName5
          ? this.subjectName5["Course_code"]
          : this.withoutCodeSub5,
        course_code_sixth: this.subjectName6
          ? this.subjectName6["Course_code"]
          : this.withoutCodeSub6,
        course_code_seventh: this.subjectName7
          ? this.subjectName7["Course_code"]
          : this.withoutCodeSub7,
        course_code_eight: this.subjectName8
          ? this.subjectName8["Course_code"]
          : this.withoutCodeSub8,
        course_code_ninth: this.subjectName9
          ? this.subjectName9["Course_code"]
          : this.withoutCodeSub9,
        course_code_tenth: this.subjectName10
          ? this.subjectName10["Course_code"]
          : this.withoutCodeSub10,

        course_code_edit_first : this.edu_form.controls.courseEdit1Ctrl.value.toUpperCase(),
          course_code_edit_second : this.edu_form.controls.courseEdit2Ctrl.value.toUpperCase(),
          course_code_edit_third : this.edu_form.controls.courseEdit3Ctrl.value.toUpperCase(),
          course_code_edit_fourth : this.edu_form.controls.courseEdit4Ctrl.value.toUpperCase(),
          course_code_edit_fifth : this.edu_form.controls.courseEdit5Ctrl.value.toUpperCase(),
          course_code_edit_sixth : this.edu_form.controls.courseEdit6Ctrl.value.toUpperCase(),
          course_code_edit_seventh : this.edu_form.controls.courseEdit7Ctrl.value.toUpperCase(),
          course_code_edit_eight : this.edu_form.controls.courseEdit8Ctrl.value.toUpperCase(),
          course_code_edit_ninth : this.edu_form.controls.courseEdit9Ctrl.value.toUpperCase(),
          course_code_edit_tenth : this.edu_form.controls.courseEdit10Ctrl.value.toUpperCase(),

          
        subject_edit_First : this.edu_form.controls.subjectEditFirstCtrl.value.toUpperCase(),
        subject_edit_Second : this.edu_form.controls.subjectEditSecondCtrl.value.toUpperCase(),
        subject_edit_Third : this.edu_form.controls.subjectEditThirdCtrl.value.toUpperCase(),
        subject_edit_Fourth : this.edu_form.controls.subjectEditFourthCtrl.value.toUpperCase(),
        subject_edit_Fifth : this.edu_form.controls.subjectEditFifthCtrl.value.toUpperCase(),
        subject_edit_Sixth : this.edu_form.controls.subjectEditSixthCtrl.value.toUpperCase(),
        subject_edit_Seventh : this.edu_form.controls.subjectEditSeventhCtrl.value.toUpperCase(),
        subject_edit_Eight : this.edu_form.controls.subjectEditEightCtrl.value.toUpperCase(),
        subject_edit_Ninth : this.edu_form.controls.subjectEditNinthCtrl.value.toUpperCase(),
        subject_edit_Tenth : this.edu_form.controls.subjectEditTenthCtrl.value.toUpperCase(),

        // coursePreCodeFirst : this.edu_form.controls.courseEdit1Ctrl.value,
        // coursePreCodeSecond : this.edu_form.controls.courseEdit2Ctrl.value,
        // coursePreCodeThird : this.edu_form.controls.codePreThirdCtrl.value,
        // coursePreCodeFourth : this.edu_form.controls.codePreFourthCtrl.value,
        // coursePreCodeFifth : this.edu_form.controls.codePreFifthCtrl.value,
        // coursePreCodeSixth : this.edu_form.controls.courseEdit6Ctrl.value,
        // coursePreCodeSeventh : this.edu_form.controls.courseEdit7Ctrl.value,
        // coursePreCodeEight : this.edu_form.controls.courseEdit8Ctrl.value,
        // coursePreCodeNinth : this.edu_form.controls.courseEdit9Ctrl.value,
        // coursePreCodeTenth : this.edu_form.controls.courseEdit10Ctrl.value,
        credits_pre_Earned_c_First : this.edu_form.controls.creditsEarnedCFirstCtrl.value,
        credits_pre_Earned_c_Second : this.edu_form.controls.creditsEarnedCSecondCtrl.value,
        credits_pre_Earned_c_Third : this.edu_form.controls.creditsEarnedCThirdCtrl.value,
        credits_pre_Earned_c_Fourth : this.edu_form.controls.creditsEarnedCFourthCtrl.value,
        credits_pre_Earned_c_Fifth : this.edu_form.controls.creditsEarnedCFifthCtrl.value,
        credits_pre_Earned_c_Sixth : this.edu_form.controls.creditsEarnedCSixthCtrl.value,
        credits_pre_Earned_c_Seven : this.edu_form.controls.creditsEarnedCSevenCtrl.value,
        credits_pre_Earned_c_Eight : this.edu_form.controls.creditsEarnedCEightCtrl.value,
        credits_pre_Earned_c_Ninth : this.edu_form.controls.creditsEarnedCNinthCtrl.value,
        credits_pre_Earned_c_tenth : this.edu_form.controls.creditsEarnedCtenthCtrl.value,
        gpa_sem_I_Details : this.edu_form.controls.sem1gpadetailsctrl.value,
        gpa_sem_II_Details : this.edu_form.controls.sem2gpadetailsctrl.value,
        gpa_sem_III_Details : this.edu_form.controls.sem3gpadetailsctrl.value,
        gpa_sem_IV_Details : this.edu_form.controls.sem4gpadetailsctrl.value,
        gpa_sem_V_Details : this.edu_form.controls.sem5gpadetailsctrl.value,
        footnotes : this.edu_form.controls.footnotesCtrl.value,
        sgpiInstruction : this.edu_form.controls.sgpiInstCtrl.value,
        stillStdMonth : this.edu_form.controls.stlStdmonthCtrl.value,
        sgpi_gpa : 'gpa'
      }
 
      this.api.setEducationalValues(edu_data)
      .subscribe(
        (data: any) => {  
          this.ref.close(data);
          err => console.error(err)
      });
    }
  }




  dismiss() {
    
   if( this.yearStart != '' &&  this.yearStart != null &&  this.yearStart != undefined ){
     var edu_data = {
      id : this.edu_id,
      startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
     }
    
     this.api.setEducationalYear(edu_data)
     .subscribe(
       (data: any) => {  
         this.ref.close(data);
         err => console.error(err)
     });
   }
    this.ref.close();
  }


  onDeleteSubject(no){
    

    this.api.deleteRecords(this.user_id,this.edu_id,no)
    .subscribe(data => {
      if(data["status"]==200){
        this.getEduDetails();
        this.toasterService.success("Deleted successfully");
      }
    },
    (err)=>console.error(err)
    );
  }


  myFunc(){
    this.totalMarks = 0
    this.totalMarksOut=0
    if(this.edu_form.controls.markFirstCtrl.value && this.edu_form.controls.internalMarksCtrl.value){
      this.totalValue = parseInt(this.edu_form.controls.markFirstCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)
      if(this.totalValue>0){
        this.totalMarks = this.totalMarks + this.totalValue;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
    if(this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.markSecondCtrl.value){
     
      this.totalValue2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.markSecondCtrl.value)
      if(this.totalValue2>0){
        this.totalMarks = this.totalMarks + this.totalValue2;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }

    if(this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.markThirdCtrl.value){
     
      this.totalValue3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.markThirdCtrl.value)
      if(this.totalValue3>0){
        this.totalMarks = this.totalMarks + this.totalValue3;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
    if(this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.markFourthCtrl.value){
     
      this.totalValue4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.markFourthCtrl.value)
      if(this.totalValue4>0){
        this.totalMarks = this.totalMarks + this.totalValue4;
        this.totalMarksOut=this.totalMarksOut+100
      }
   
    }
    if(this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.markFifthCtrl.value){
     
      this.totalValue5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.markFifthCtrl.value)
      if(this.totalValue5>0){
        this.totalMarks = this.totalMarks + this.totalValue5;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
    if(this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.markSixthCtrl.value){
     
      this.totalValue6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.markSixthCtrl.value)
      if(this.totalValue6>0){
        this.totalMarks = this.totalMarks + this.totalValue6;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
    if(this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.markSeventhCtrl.value){
     
      this.totalValue7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.markSeventhCtrl.value)
      if(this.totalValue7>0){
        this.totalMarks = this.totalMarks + this.totalValue7;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
    if(this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.markEighthCtrl.value){
     
      this.totalValue8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.markEighthCtrl.value)
      if(this.totalValue8>0){
        this.totalMarks = this.totalMarks + this.totalValue8;
        this.totalMarksOut=this.totalMarksOut+100
      }
   
    }
    if(this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.markNinthCtrl.value){
     
      this.totalValue9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.markNinthCtrl.value)
      if(this.totalValue9>0){
        this.totalMarks = this.totalMarks + this.totalValue9;
        this.totalMarksOut=this.totalMarksOut+100
      }
   
    }
    if(this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.markTenthCtrl.value){
     
      this.totalValue10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.markTenthCtrl.value)
      if(this.totalValue10>0){
        this.totalMarks = this.totalMarks + this.totalValue10;
        this.totalMarksOut=this.totalMarksOut+100
      }
    }
   
   
  }

  overAlltotal(){
    this.over_All_Total = 0
    if(this.edu_form.controls.markFirstCtrl.value && this.edu_form.controls.internalMarksCtrl.value && this.edu_form.controls.pracFirstCtrl.value){
      this.total_value1 = parseInt(this.edu_form.controls.markFirstCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)+parseInt(this.edu_form.controls.pracFirstCtrl.value)
      if(this.total_value1>0){
        this.over_All_Total = this.over_All_Total + this.total_value1;
      }
    }
    if(this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.markSecondCtrl.value && this.edu_form.controls.pracSecondCtrl.value){
     
      this.total_value2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.markSecondCtrl.value)+ parseInt(this.edu_form.controls.pracSecondCtrl.value)
      if(this.total_value2>0){
        this.over_All_Total = this.over_All_Total + this.total_value2;
      }
    }

    if(this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.markThirdCtrl.value && this.edu_form.controls.pracThirdCtrl.value){
     
      this.total_value3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.markThirdCtrl.value)+ parseInt(this.edu_form.controls.pracThirdCtrl.value)
      if(this.total_value3>0){
        this.over_All_Total = this.over_All_Total + this.total_value3;
      }
    }
    if(this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.markFourthCtrl.value && this.edu_form.controls.pracFourthCtrl.value){
     
      this.total_value4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.markFourthCtrl.value)+ parseInt(this.edu_form.controls.pracFourthCtrl.value)
      if(this.total_value4>0){
        this.over_All_Total = this.over_All_Total + this.total_value4;
      }
   
    }
    if(this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.markFifthCtrl.value && this.edu_form.controls.pracFifthCtrl.value){
     
      this.total_value5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.markFifthCtrl.value) + parseInt(this.edu_form.controls.pracFifthCtrl.value)
      if(this.total_value5>0){
        this.over_All_Total = this.over_All_Total + this.total_value5;
      }
    }
    if(this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.markSixthCtrl.value && this.edu_form.controls.pracSixthCtrl.value){
     
      this.total_value6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.markSixthCtrl.value) + parseInt(this.edu_form.controls.pracSixthCtrl.value)
      if(this.total_value6>0){
        this.over_All_Total = this.over_All_Total + this.total_value6;
      }
    }
    if(this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.markSeventhCtrl.value && this.edu_form.controls.pracSeventhCtrl.value){
     
      this.total_value7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.markSeventhCtrl.value) + parseInt(this.edu_form.controls.pracSeventhCtrl.value)
      if(this.total_value7>0){
        this.over_All_Total = this.over_All_Total + this.total_value7;
      }
    }
    if(this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.markEighthCtrl.value && this.edu_form.controls.pracEightCtrl.value){
     
      this.total_value8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.markEighthCtrl.value)+ parseInt(this.edu_form.controls.pracEightCtrl.value)
      if(this.total_value8>0){
        this.over_All_Total = this.over_All_Total + this.total_value8;
      }
   
    }
    if(this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.markNinthCtrl.value && this.edu_form.controls.pracNineCtrl.value){
     
      this.total_value9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.markNinthCtrl.value) + parseInt(this.edu_form.controls.pracNineCtrl.value)
      if(this.total_value9>0){
        this.over_All_Total = this.over_All_Total + this.total_value9;
      }
   
    }
    if(this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.markTenthCtrl.value && this.edu_form.controls.pracTenCtrl.value){
     
      this.total_value10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.markTenthCtrl.value) + parseInt(this.edu_form.controls.pracTenCtrl.value)
      if(this.total_value10>0){
        this.over_All_Total = this.over_All_Total + this.total_value10;
      }
    }
   
   
  }

  hetmarksObt(){
    this.totalMarks = 0
    
    if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) )
      
    }else if(this.edu_form.controls.markSecondCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }
  }

 totalsMarksOut(){
   this.totalMarksOut = 0
   if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
   }
 }

 getTotalCredits(){
   this.creditTotal = 0
   if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.creditsEarnedCtenthCtrl.value){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCtenthCtrl.value))
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value))
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value))
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) )
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value ){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) )
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value ){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value)  )
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value ){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) )
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value ){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) )
   }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value ){
    this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) )
   }

 }


 getTotalCnG(){
  this.totalCnG = 0;
 
  if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.gradepointsFirstCtrl.value){
      this.C_into_G = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) *  Number(this.edu_form.controls.gradepointsFirstCtrl.value))
   
 
      if(this.C_into_G>0){
        this.totalCnG = this.totalCnG + this.C_into_G;
 
        if(this.totalCnG && this.creditTotal){
          this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
         }
      }
    }
  if(this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.gradepointsSecondCtrl.value){
     this.C_into_G2 = (Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) *  Number(this.edu_form.controls.gradepointsSecondCtrl.value))
 
     if(this.C_into_G2>0){
      this.totalCnG = this.totalCnG + this.C_into_G2;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.gradepointsThirdCtrl.value){
    this.C_into_G3 = (Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) *  Number(this.edu_form.controls.gradepointsThirdCtrl.value))
   
    if(this.C_into_G3>0){
      this.totalCnG = this.totalCnG + this.C_into_G3;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.gradepointsFourthCtrl.value){
    this.C_into_G4 = (Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) *  Number(this.edu_form.controls.gradepointsFourthCtrl.value))
 
    if(this.C_into_G4>0){
      this.totalCnG = this.totalCnG + this.C_into_G4;
 
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
 
   }
   if(this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.gradepointsFifthCtrl.value){
    this.C_into_G5 = (Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) *  Number(this.edu_form.controls.gradepointsFifthCtrl.value))
 
    if(this.C_into_G5>0){
      this.totalCnG = this.totalCnG + this.C_into_G5;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.gradepointsSixthCtrl.value){
    this.C_into_G6 = (Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) *  Number(this.edu_form.controls.gradepointsSixthCtrl.value))
    if(this.C_into_G6>0){
      this.totalCnG = this.totalCnG + this.C_into_G6;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.gradepointsSeventhCtrl.value){
    this.C_into_G7 = (Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) *  Number(this.edu_form.controls.gradepointsSeventhCtrl.value))
    if(this.C_into_G7>0){
      this.totalCnG = this.totalCnG + this.C_into_G7;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.gradepointsEighthCtrl.value){
    this.C_into_G8 = (Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) *  Number(this.edu_form.controls.gradepointsEighthCtrl.value))
    if(this.C_into_G8>0){
      this.totalCnG = this.totalCnG + this.C_into_G8;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.gradepointsNinthCtrl.value){
    this.C_into_G9 = (Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) *  Number(this.edu_form.controls.gradepointsNinthCtrl.value))
    if(this.C_into_G9>0){
      this.totalCnG = this.totalCnG + this.C_into_G9;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
   }
   if(this.edu_form.controls.creditsEarnedCtenthCtrl.value && this.edu_form.controls.gradepointsTenthCtrl.value){
    this.C_into_G10 = (Number(this.edu_form.controls.creditsEarnedCtenthCtrl.value) *  Number(this.edu_form.controls.gradepointsTenthCtrl.value))
    if(this.C_into_G10>0){
      this.totalCnG = this.totalCnG + this.C_into_G10;
 
      if(this.totalCnG && this.creditTotal){
        this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
        this.totalcgpa = Number(this.totalcgpa.toFixed(2))
       }
    }
 
   }

  //to check which form control is invalid
// public findInvalidControls(controls) {
// const invalid = [];
 
// for (const name in controls) {
// if (controls[name].invalid) {
// invalid.push(name);
// }
// }
// return invalid;
  //   }
}

onChange(event,no) {
  if(no=='1'){
    if(event.checked == true){
      this.instruction1 = true;
      this.special_instruction1 = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'
    }
    if(event.checked == false){
      this.instruction1 = false;
      this.special_instruction1 = null
    }
  }else if(no=='2'){
    if(event.checked == true){
      this.instruction2 = true;
      this.special_instruction2 = '& Scaled Down, Cir. No. UG/61 of 2013-2014'
    }
    if(event.checked == false){
      this.instruction2 = false;
      this.special_instruction2 = null
    }
  }else if(no=='3'){
    if(event.checked == true){
      this.instruction3 = true;
      this.special_instruction3 = '+ Carried Forward Marks as per Ordinance of University of Mumbai'
    }
    if(event.checked == false){
      this.instruction3 = false;
      this.special_instruction3 = null
    }
  }else if(no=='4'){
    if(event.checked == true){
      this.instruction4 = true;
      this.special_instruction4 = '* As per University of Mumbai Ordinance 0.5045a'
    }
     if(event.checked == false){
      this.instruction4 = false;
      this.special_instruction4 = null
    }
  }else if(no=='5'){
    if(event.checked == true){
      this.instruction5 = true;
      this.special_instruction5 = '$ - Carried forward grade as per ordinance of the University of Mumbai'
    }
    if(event.checked == false){
      this.instruction5 = false;
      this.special_instruction5 = null
    }
  }else if(no=='6'){
    if(event.checked == true){
      this.instruction6 = true;
      this.special_instruction6 = '# As per University of Mumbai, Ordinance 0.229'
    }
    if(event.checked == false){
      this.instruction6 = false;
      this.special_instruction6 = null
    }
  }else if(no=='7'){
    if(event.checked == true){
      this.instruction7 = true;
      this.special_instruction7 = '& As per University of Mumbai Ordinance. O.224'
    }
    if(event.checked == false){
      this.instruction7 = false;
      this.special_instruction7 = null
    }
  }
  
}

updateSpecialInstruction(val){
  this.specialInstruction = val
}

getSpecialInst(event : any){
 
  this.specialInstruction = event.target.value
 
}

updateGradeSpecialInstruction(val){
 
  this.GradespecialInstruction = val
}

getGradeSpecialInst(event : any){
 
  this.GradespecialInstruction = event.target.value
 
}

showcoursecodeDropdown() {
  this.showcodeDropdown = true;
}

showcoursecodeDropdown2() {
  this.showcodeDropdown2 = true;
}

showcoursecodeDropdown3() {
  this.showcodeDropdown3 = true;
}

showcoursecodeDropdown4() {
  this.showcodeDropdown4 = true;
}

showcoursecodeDropdown5() {
  this.showcodeDropdown5 = true;
}

showcoursecodeDropdown6() {
  this.showcodeDropdown6 = true;
}

showcoursecodeDropdown7() {
  this.showcodeDropdown7 = true;
}

showcoursecodeDropdown8() {
  this.showcodeDropdown8 = true;
}

showcoursecodeDropdown9() {
  this.showcodeDropdown9 = true;
}

showcoursecodeDropdown10() {
  this.showcodeDropdown10 = true;
}

// decimalFilter(event: any) {

//   const reg = "/^[0-9]*(\.[0-9]{0,2})?$/";
//   let input = event.target.value + String.fromCharCode(event.charCode);

  // if (!reg.test(input)) {
  //     event.preventDefault();
  // }
// }

}